import { useMemo } from "react";
import { ViewType } from "./types";

const useUserViews = (uuid?: string, views?: Record<string, any>) => {
  const userViews = useMemo(() => {
    if (!views) {
      console.warn("User or user views are missing.");
      return [];
    }

    const selectedUUID = getUUIDOrFirstAvailable(uuid, views);
    if (!selectedUUID) {
      console.warn("No UUID available.");
      return [];
    }

    const selectedViews = views[selectedUUID];
    if (!selectedViews) {
      console.warn("No views found for UUID:", selectedUUID);
      return [];
    }

    return transformViewsToArray(selectedViews);
  }, [uuid, views]);

  return { userViews };
};

const getUUIDOrFirstAvailable = (
  uuid: string | undefined,
  userViews: Record<string, any> | undefined,
): string | undefined => {
  if (uuid) return uuid;
  if (userViews) {
    const [firstUUID] = Object.keys(userViews);
    return firstUUID;
  }
};

const transformViewsToArray = (views: Record<string, string>): ViewType[] => {
  return Object.entries(views).map(([name, path]) => ({ name, path }));
};

export default useUserViews;
